// src/api/index.js
import axios from 'axios';
import { getUserToken } from '../js/Base/LocalStorageUtils';
import toastAlert from '../js/Base/ToastAlert';
import { forceLogout } from '../js/Base/tokenManager';
const BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://127.0.0.1:8000/api/';

export const createApiInstance = (servicePath = '') => {
  const token = getUserToken();

  const instance = axios.create({
    baseURL: `${BASE_URL}${servicePath}`,
    headers: {
      'Content-Type': 'application/json',
      ...(token && { 'X-Auth-Token': token }),
    },
    withCredentials: false, // 若不使用 Django session 認證
  });

  // 自動攔截401錯誤，可在這裡做自動登出或token刷新
  instance.interceptors.response.use(
    (response) => response,
    (error) => {
      if (error.response && error.response.status === 401) {
        console.warn('Token 失效或未授權');
        // 這裡可以自動清除token或導向登入頁
        error.__handled = true;
        toastAlert.autoClose(true).showError('Token expired');
        forceLogout();
      }
      return Promise.reject(error);
    }
  );

  return instance;
};
